function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import { Link } from '../utils';

var Social =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Social, _React$Component);

  function Social() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Social.prototype;

  _proto.render = function render() {
    return React.createElement("div", {
      className: "social-links"
    }, _.map(_.get(this.props, 'pageContext.site.data.social.links'), function (link, link_idx) {
      return link && React.createElement(Link, {
        key: link_idx,
        to: _.get(link, 'url'),
        target: "_blank",
        rel: "noopener"
      }, React.createElement("span", {
        className: 'fab ' + _.get(link, 'icon'),
        "aria-hidden": "true"
      }), React.createElement("span", {
        className: "screen-reader-text"
      }, _.get(link, 'title')));
    }));
  };

  return Social;
}(React.Component);

export { Social as default };